<template>
  <div class="psd-container">
    <div class="psd-element">
      <h2 class="scalable-psd-title">{{ $t('home.pre-home.scalablePsd.title') }}</h2>
      <div class="scalable-psd-subtitle">{{ $t('home.pre-home.scalablePsd.subtitle') }}</div>
      <div class="w-100 d-flex justify-content-center align-items-center mt-5">
        <Button
          color="merch-color"
          text="white"
          :to="$urlBuilder('landing', { uid: 'psd-t-shirt-designs' })"
        >
          {{ $t('home.pre-home.scalablePsd.button') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'UI/Button';

export default {
  components: {
    Button
  }
};
</script>

<style lang="scss" scoped>
.psd-container {
  height: 498px;
  background-color: #f3f3f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('https://cdn.vexels.com/img/scalable-t-shirt-psd.jpg?fmt=webp') no-repeat center
    center;
  display: flex;
  @include md {
    height: auto;
    padding: 0 0 15px 0;
    background-size: cover;
  }
  .psd-element {
    flex-grow: 1;
  }
}
.scalable-psd-title {
  color: #f3f3f3;
  font-size: 64px;
  text-align: center;
  font-weight: 500;
  padding: 10px 0;
  @include lg {
    font-size: 41px;
  }
}
.scalable-psd-subtitle {
  color: #f3f3f3;
  font-size: 18px;
  text-align: center;
  margin: 30px 0px;
}
</style>
